import { Link, withRouter } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { useRouteMatch } from 'react-router-dom'
import { Breadcrumb, Button } from 'antd'
import { StyledTaskTable } from './styled'
import Feather from '@sysunite/react-feather'
import { PageContainer, StyledFooter } from '../shared'
import './index.scss'

function Tasks () {
  const { params: { spaceId } } = useRouteMatch()

  const icon = <Feather type="plus" style={{ height: 16, margin: '-3px 3px' }} />

  const { data, isLoading } = useQuery(
    ['weaver-orchestrator'],
    () => Weaver.Plugin.load('weaver-orchestrator')
  )

  return (
    <PageContainer>
      <Breadcrumb style={{ margin: 20, marginBottom: 0 }}>
        <Breadcrumb.Item>
          { Weaver.getInstance().currentProject()?.name() }
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <Link to={`/${ spaceId }/pipelines/tasks`}>
            Tasks
          </Link>
        </Breadcrumb.Item>
      </Breadcrumb>
      {
        !isLoading &&
          <StyledTaskTable
            data-testid="task-table"
            orchestrator={data}
          />
      }
      <StyledFooter>
        <Link to={`/${ spaceId }/pipelines/tasks/new`}>
          <Button
            data-testid="create-new-task-button"
            icon={icon}
          >
            Create a Task
          </Button>
        </Link>
      </StyledFooter>
    </PageContainer>
  )
}

export default withRouter(Tasks)
